import './index.css'

import React from 'react'
import { Component } from 'react'

import TextInput from '../../../components/text-input'
import TextEditor from '../../../components/text-editor'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip'

class BasicsComponent extends Component {
  constructor(props) {
    super(props)

    this.state = { model: props.model }
    this.summaryHeader = this.props.summaryHeader
  }

  update = (field, value) => {
    let model = this.state.model
    model[field] = value
    this.setState({ model: model })

    this.props.update('basics', this.state.model)
  }

  updateLocation = (field, value) => {
    let model = this.state.model
    model.location[field] = value
    this.setState({ model: model })

    this.props.update('basics', this.state.model)
  }

  updateHeaders = (index, model) => {
    this.props.updateHeaders('summary', model)
  }

  render() {
    return (
      <React.Fragment>
        <div className="section-basics-line">
          <div className="section-basics-title">Personal information</div>
        </div>

        <div className="section-basics-line">
          <TextInput
            field="label"
            help="Complete with your current job title, profession or role."
            label="Job Title"
            value={this.state.model.label}
            update={this.update}
          />

          <TextInput
            field="name"
            help="Complete with your full name."
            label="Full Name"
            value={this.state.model.name}
            update={this.update}
          />
        </div>

        <div className="section-basics-line">
          <TextInput
            field="email"
            label="Email"
            value={this.state.model.email}
            update={this.update}
          />

          <TextInput
            field="phone"
            label="Phone"
            value={this.state.model.phone}
            update={this.update}
          />
        </div>

        <div className="section-basics-line">
          <TextInput
            field="country"
            label="Country"
            value={this.state.model.location.country}
            update={this.updateLocation}
          />

          <TextInput
            field="city"
            label="City"
            value={this.state.model.location.city}
            update={this.updateLocation}
          />
        </div>

        <br />

        <div>
          <div className="section-basics-title">
            <div className="pencil-edit" data-tip data-for="summary-pencil-edit">
              <FontAwesomeIcon icon={faPen} className="fa-flip-horizontal" />
              <ReactTooltip id="summary-pencil-edit" type="dark" effect="solid" place="top">
                <p style={{ maxWidth: '200px' }}>You can edit this header.</p>
              </ReactTooltip>
            </div>
            <TextInput
              field="summary"
              value={this.summaryHeader}
              update={this.updateHeaders}
              placeholder="Summary"
              showBorderBottom={false}
            />
          </div>
          <TextEditor
            field="summary"
            label="Tell us about your experience, your skills and something about your future work expectation."
            value={this.state.model.summary}
            update={this.update}
          />
        </div>
      </React.Fragment>
    )
  }
}

export default BasicsComponent
